import {makeStyles} from "@mui/styles";

export const useCardStyles = makeStyles(() => ({
    root: {
        marginBottom: "20px",
        padding: "20px",
        paddingTop: "16px",
        boxSizing: "border-box",
        background: "white",
        borderRadius: "14px",
        border: "1px solid #F0F0F0",
    }
}));

export const dialogTitleStyles = {
    dialogTitle: {
        background: "#FF3F3F",
        "& .MuiTypography-h3": {
            color: "white",
            textAlign: "left",
        }
    }
};
